import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { getSpacingSchema } from './spacing.schema';

/**
 * The schema for the logout component form.
 * Defines the fields to display for the form.
 */
export const LOGOUT_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...getSpacingSchema({
      default: {
        top: 4,
        right: 2,
        bottom: 4,
        left: 2
      }
    }),
    {
      type: 'checkbox',
      formControlName: 'showLogoutMessage',
      label: 'components.logout.schema.showMessage.label',
      description: 'components.logout.schema.showMessage.description',
      default: true
    }
  ]
};
